import { Component, OnInit } from '@angular/core';
import { TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { IExam, IExaminationReviewer } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-exam-reviewers',
  templateUrl: './exam-reviewers.component.html',
  styleUrls: ['./exam-reviewers.component.scss']
})
export class ExamReviewersComponent implements OnInit {

  exam: IExam = examDefault;

  examinationReviewer: IExaminationReviewer = {
    examinationID: 0,
    user: '',
    id: 0
  };

  users: any[] = [];

  constructor(
    private examService: ExamService,
    private snackBar: SnackbarService,
    private evnt: EventService
  ) { }

  ngOnInit() {
    GridUtil.setClearGridSelection();
    this.exam = this.examService.selectedExams[0];

    this.evnt.addExaminerMessageEvent.subscribe(() => {
      this.refreshData(this.data.tableParams);
    });

    this.refreshData(this.data.tableParams);
  }

  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [],
      sortParam: {
        fieldName: "",
        orderDirection: 0
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Examination ID',
      fieldName: 'examinationID',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,
    },
    {
      displayName: 'Username',
      fieldName: 'user',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,
    },
  ];

  updateGridParams(res: any) {
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo };
    this.data.tableParams = tableParams;
    this.data.tableRows.push(...res.slice(1));
  }

  async refreshData(tableParams: any) {
    tableParams.ExaminationID = this.exam.id;
    const res = await this.examService.getExaminationReviewerTable(tableParams) as any[];
    this.updateGridParams(res);
  }

  emitReviewerData(Ids: any[]) {
    const reviewerList: any[] = [];
    Ids.forEach(x => reviewerList.push(this.data.tableRows[x]));

    this.examinationReviewer = reviewerList[0];

    const selectedDataRowsId = reviewerList.map(x => x.id);
    GridUtil.setRowCliclk("examReviewerGrid", Ids, selectedDataRowsId);
  }

  removeReviewer() {
    this.examService.deleteExaminationReviewer(this.examinationReviewer).then(async () => {
      await this.refreshData(this.data.tableParams);
      this.snackBar.success('Reviewer deleted successfully!!');
    });
  }
}